import { Injectable } from '@angular/core';
import { Action, State, StateContext, dispatch } from '@ngxs/store';
import { UpsertClientIntakeFormItems } from '@db-access/clientIntakeFormItems';
import { CreateIntakeFormItems } from './intake-form-items.actions';
import { firstValueFrom } from 'rxjs';

@State({
	name: 'intakeFormItems',
	defaults: {},
})
@Injectable()
export class IntakeFormItemsState {
	upsertClientIntakeFormItems = dispatch(UpsertClientIntakeFormItems);

	@Action(CreateIntakeFormItems)
	async createItems(
		ctx: StateContext<Record<string, never>>,
		action: CreateIntakeFormItems,
	): Promise<void> {
		const now = Date.now();
		const itemsWithTimestamps = action.items.map((item) => ({
			...item,
			createdAt: now,
			updatedAt: now,
		}));

		await firstValueFrom(this.upsertClientIntakeFormItems(itemsWithTimestamps));
	}
}
